<template>
  <!-- Create Farm Modal -->
  <div class="o-modal">
    <div class="o-modal-content big">
      <div class="o-modal-header">
        <!-- <a
          @click="closeModal()"
          class="close clickable"
        ><i class="far fa-times"
        ></i></a> -->
        <p class="lead">Create First Farm</p>
      </div><!-- /.o-modal-header -->
      <form @submit.prevent>
        <div class="o-modal-body">
          <div class="row">
            <div class="col-md-3">
              <p><small>Click on the map to select a location for your farm.</small></p>
              <div class="form-group">
                <label for="farmName">Farm Name</label>
                <input
                  v-model="farm.name"
                  id="farmName"
                  class="form-control"
                />
              </div><!-- /.form-group -->
            </div><!-- /.col-md-3 -->
            <div class="col-md-9 p-0">

              <!-- FARM LOCATION PICKER -->
              <div class="map" id="farmLocationMap" style="height:470px;"></div>

            </div><!-- /.col-md-9 -->
          </div><!-- /.row -->
        </div><!-- /.o-modal-body -->
        <div class="o-modal-footer">
          <div class="float-right w-100">
            <button
              @click="saveFarm()"
              class="btn btn-primary mr-1 float-right"
            >Create Farm</button>
            <b-btn
              @click="logout()"
              class="mt-1 float-left"
              size="sm"
            >
              <i class="far fa-sign-out-alt"></i> Log out
            </b-btn>
          </div><!-- /.btn-group -->
        </div><!-- /.o-modal-footer -->
      </form>
    </div><!-- /.o-modal-content -->
    <Confirm
      v-if="confirmDelete"
      text="DANGER! Are you sure you want to delete this farm? This will also delete any datasets that belong to this farm. This cannot be undone!"
      v-on:confirmed="deleteFarm($event)"
    />
  </div><!-- /.o-modal -->
</template>

<script>
import Confirm from '../Confirm'
import firebase from 'firebase/compat/app'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      confirmDelete: false
    }
  },
  components: {
    Confirm
  },
  mounted () {
    if (this.$store.state.display.editMode === false) {
      this.farm.name = ''
      this.farm.geolocation = null
    }
    this.initMap()
  },
  computed: {
    farm: {
      get () {
        return this.$store.state.farm
      },
      set (value) {
        this.$store.commit('setFarm', value)
      }
    }
  },
  methods: {
    logout () {
      fb.auth.signOut().then(() => {
        this.$store.commit('toggleModal', 'firstFarmModal')
        this.$store.dispatch('clearUserData')
        this.$router.push('/login')
      }).catch(err => {
        console.log(err)
      })
    },
    closeModal () {
      location.reload()
    },
    deleteFarm (confirmed) {
      const farmId = this.$store.state.farm.id
      if (confirmed) {
        this.confirmDelete = false
        if (farmId === this.$store.state.userProfile.defaultFarm) {
          fb.usersCollection.doc(this.$store.state.currentUser.uid).update({
            defaultFarm: false
          })
        }
        // Get all Blocks with this Farm ID
        fb.blocksCollection.where('farmId', '==', farmId).get().then(blocks => {
          // Perform Block Delete process for each
          blocks.forEach(block => {
            // Get this block's maps
            // fb.mapsCollection.where('blockId', '==', block.id).get().then(maps => {
            //   // For each map, delete geojson file and grid file
            //   maps.forEach(map => {
            //     const mediaPath = map.data().geoJsonPath
            //     const fileRef = fb.storage.ref(mediaPath)
            //     fileRef.delete()
            //     if (map.data().interpolatedGeoJsonPath) {
            //       const interpolatedMediaPath = map.data().interpolatedGeoJsonPath
            //       const interpolatedFileRef = fb.storage.ref(interpolatedMediaPath)
            //       interpolatedFileRef.delete()
            //     }
            //     if (map.data().gridPath) {
            //       const gridPath = map.data().gridPath
            //       const gridFileRef = fb.storage.ref(gridPath)
            //       gridFileRef.delete()
            //     }
            //     fb.mapsCollection.doc(map.id).delete()
            //   })
            // }).catch(err => { console.log(err) })
            fb.blocksCollection.doc(block.id).delete()
          })
          return true
        }).then(() => {
          // Get all Datasets  with this Farm ID
          return fb.datasetsCollection.where('farmId', '==', farmId).get()
        }).then(datasets => {
          // Perform Dataset Delete process for each
          datasets.forEach(dataset => {
            // Delete this datasets files
            const rawPath = dataset.data().file.path
            const rawFileRef = fb.storage.ref(rawPath)
            rawFileRef.delete()
            const geoPath = dataset.data().file.geoJsonPath
            const geoFileRef = fb.storage.ref(geoPath)
            geoFileRef.delete()
            // Delete this datasets document
            fb.datasetsCollection.doc(dataset.id).delete()
          })
          return true
        }).then(() => {
          if (this.farm.blocksGeoJsonPath) {
            // Delete the Farm Blocks geoJson and farm Document
            const blocksPath = this.farm.blocksGeoJsonPath
            const blocksFileRef = fb.storage.ref(blocksPath)
            blocksFileRef.delete()
          }
          return fb.farmsCollection.doc(farmId).delete()
        }).then(() => {
          window.location.href = '/'
        }).catch(err => { console.log(err.message) })
      } else {
        this.confirmDelete = false
        return false
      }
    },
    initMap () {
      const self = this
      mapboxgl.accessToken = 'pk.eyJ1IjoibGVyZ3AiLCJhIjoiY2p4bmI1NzNzMGN0MTNjcGx4cjF4eDBtdSJ9.2C0FEHhNZ-jGd7jgIRTrEQ' // eslint-disable-line
      // If in edit mode, use current farm coordinates
      let center = [-95, 40]
      let zoom = 3
      let lat
      let lng
      if (this.$store.state.display.editMode === true && this.$store.state.farm.geolocation) {
        if (this.$store.state.farm.geolocation.latitude) {
          // Get Farm Coordinates
          lat = this.$store.state.farm.geolocation.latitude
          lng = this.$store.state.farm.geolocation.longitude
          center = [lng, lat]
          zoom = 16
        }
      }
      /* eslint-disable */
      let map = new mapboxgl.Map({
        container: 'farmLocationMap',
        style: 'mapbox://styles/mapbox/satellite-v9',
        center: center,
        zoom: zoom
      })
      map.scrollZoom.disable()

      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        marker: false
      })

      map.addControl(geocoder)

      geocoder.on('result', function(results) {
        // console.log(results)
      })

      map.addControl(new mapboxgl.NavigationControl())

      // CLICK TO ADD MARKER
      let selectMarker = null
      function addMarker(e) {
        if (selectMarker != null) {
          selectMarker.remove()
        }
        let markerOptions = e
        markerOptions.color = 'orange'
        // markerOptions.draggable = true
        selectMarker = new mapboxgl.Marker(markerOptions)
          .setLngLat(e.lngLat)
          .addTo(map)
        self.farm.geolocation = new firebase.firestore.GeoPoint(e.lngLat.lat, e.lngLat.lng)
      }
      map.on('click', addMarker)

      if (this.$store.state.display.editMode && this.$store.state.farm.geolocation) {
        if (this.$store.state.farm.geolocation.latitude) {
          addMarker({lngLat: {
            lng: lng,
            lat: lat
          }})
        }
      }

    },
    saveFarm () {
      if (!this.farm.geolocation) {
        alert('You must select a location for your farm by searching and/or clicking on the map!')
        return false
      }
      let editMode = this.$store.state.display.editMode
      if (editMode == true) {
        fb.farmsCollection.doc(this.$store.state.farm.id).update({
          name: this.farm.name || '',
          geolocation: this.farm.geolocation || '',
          updatedOn: new Date()
        }).then(ref => {
          location.reload()
        }).catch(err => {
          console.log(err)
        })
      } else {
        // Create the farm
        fb.farmsCollection.add({
          name: this.farm.name || '',
          geolocation: this.farm.geolocation || '',
          createdOn: new Date(),
          updatedOn: new Date(),
          ownerId: this.$store.state.currentUser.uid,
          users: [],
          permissions: {}
        }).then(ref => {
          window.location.href = '/f/' + ref.id
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>
